export default __webpack_public_path__ + "static/fit-e2033cf5796bad799bfb74482d6779e4.png";